import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let pending = null;
const listeners = new Set();

export const reloadFees = () => {
  pending = api.get("/fees").then((r) => { cache = r.data; listeners.forEach((fn) => fn(cache)); return cache; }).finally(() => { pending = null; });
  return pending;
};

export const fmtUF = (v) => Number(v ?? 0).toLocaleString("es-CL", { minimumFractionDigits: 3, maximumFractionDigits: 6 });

// Tarifas vigentes (publicación y reserva) definidas por el Admin.
export function useFees() {
  const [fees, setFees] = useState(cache);
  useEffect(() => {
    listeners.add(setFees);
    if (!cache && !pending) reloadFees().catch(() => {});
    return () => { listeners.delete(setFees); };
  }, []);
  return fees;
}
